import { useState } from 'react';

import {
  EnumNotificationTechnology,
  useGetUserUnreadNotificationsCountQuery,
} from 'generated/graphql';
import { useSession } from 'providers';
import { logError } from 'utils/logError';
import { Technology } from 'utils/products';
import { isSessionExpired } from 'utils/sessionExpiry';

export const useNotificationsCount = () => {
  const [errorCount, setErrorCount] = useState(0);
  const { getExpiresIn, firebaseId } = useSession();

  const isSessionValid =
    !isSessionExpired(getExpiresIn()) && Boolean(firebaseId);
  const technology =
    Technology.availableTechnology as EnumNotificationTechnology;

  const {
    data: countData,
    startPolling: startCountPolling,
    stopPolling: stopCountPolling,
  } = useGetUserUnreadNotificationsCountQuery({
    skip: !isSessionValid,
    skipPollAttempt: () => !firebaseId,
    notifyOnNetworkStatusChange: true,
    variables: { technology },
    onCompleted: () => {
      if (errorCount > 0) setErrorCount(0);
      stopCountPolling();
      startCountPolling(5000);
    },
    onError: (error) => {
      const next = errorCount + 1;
      stopCountPolling();
      startCountPolling(Math.min(Math.pow(2, next) * 1000, 600000));
      setErrorCount(next);
      logError({ error, ignoreSentry: true });
    },
  });

  return {
    unreadCount: countData?.userUnreadNotificationsCount,
  };
};
